// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".banner-responsive {\r\n    width: 100%;\r\n    height: auto;\r\n    max-height: 200px;\r\n  }", "",{"version":3,"sources":["webpack://src/module/portal/portal.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB","sourcesContent":[".banner-responsive {\r\n    width: 100%;\r\n    height: auto;\r\n    max-height: 200px;\r\n  }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
